import { Badge, Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { BsInfoCircle } from "react-icons/bs";
import { FaCog } from "react-icons/fa";
import { TbSettingsExclamation } from "react-icons/tb";
import { useNavigate } from "react-router";

export default function AppListItem({
    app,
    appSettingsUrl,
    onInstallApp,
    onUninstallApp,
    hasCustomSettings,
    badgeText,
}) {
    const navigate = useNavigate();

    function GetNameColor(name) {
        if (name === "Corvus Drones" || name === "Corvus") {
            return "#FF8B22";
        }
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        const colorCode = (Math.abs(hash) % 360) - 280;
        return `hsla( ${colorCode}, 80%, 45%, 1.00)`;
    }

    return (
        <div className="d-flex align-items-center w-100">
            {/* Left side */}
            <div className="d-flex align-items-center flex-wrap">
                <OverlayTrigger
                    delay={{ hide: 450, show: 300 }}
                    overlay={<Tooltip>{app.description}</Tooltip>}
                    placement="top"
                >
                    <span>
                        <BsInfoCircle className="mb-1" />
                    </span>
                </OverlayTrigger>

                <span className="ms-2">{app.name}</span>

                <span
                    className="badge fw-semibold rounded-pill ms-2"
                    style={{
                        border: `1px solid ${GetNameColor(app.provider.name)}`,
                        color: GetNameColor(app.provider.name),
                    }}
                >
                    {app.provider.name}
                </span>
            </div>

            {/* Right side */}
            <div className="d-flex flex-column flex-sm-row align-items-end align-items-sm-center gap-2 ms-auto me-2">
                {(hasCustomSettings || badgeText) && (
                    <div className="d-flex align-items-center gap-2">
                        {hasCustomSettings && (
                            <TbSettingsExclamation size="22" />
                        )}

                        {badgeText && (
                            <Badge className="rounded-pill border border-secondary text-secondary bg-transparent fw-light">
                                {badgeText}
                            </Badge>
                        )}
                    </div>
                )}

                {onUninstallApp && (
                    <Button
                        as="span"
                        role="button"
                        tabIndex={0}
                        variant="outline-danger"
                        className="py-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            onUninstallApp(app.id);
                        }}
                    >
                        Uninstall
                    </Button>
                )}

                {onInstallApp && (
                    <Button
                        as="span"
                        role="button"
                        tabIndex={0}
                        variant="success"
                        className="py-0"
                        onClick={(e) => {
                            e.stopPropagation();
                            onInstallApp(app.id);
                        }}
                    >
                        Install
                    </Button>
                )}

                {appSettingsUrl && (
                    <Button
                        as="span"
                        role="button"
                        tabIndex={0}
                        variant="outline-secondary"
                        className="py-0 px-1"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(appSettingsUrl);
                        }}
                    >
                        <FaCog style={{ marginTop: "-2px" }} />
                    </Button>
                )}
            </div>
        </div>
    );
}
